"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMExpressionBytecodeCompiler = void 0;
const inversify_1 = require("inversify");
const IVMLiteralBytecodeCompiler_1 = require("../../../interfaces/vm-transformers/compilers/IVMLiteralBytecodeCompiler");
const IVMOperatorCompiler_1 = require("../../../interfaces/vm-transformers/compilers/operators/IVMOperatorCompiler");
const IVMAssignmentCompiler_1 = require("../../../interfaces/vm-transformers/compilers/assignments/IVMAssignmentCompiler");
const IVMCallCompiler_1 = require("../../../interfaces/vm-transformers/compilers/calls/IVMCallCompiler");
const IVMMemberAccessCompiler_1 = require("../../../interfaces/vm-transformers/compilers/member-access/IVMMemberAccessCompiler");
const IVMClassBytecodeCompiler_1 = require("../../../interfaces/vm-transformers/compilers/IVMClassBytecodeCompiler");
const IVMCompilerUtils_1 = require("../../../interfaces/vm-transformers/IVMCompilerUtils");
const ServiceIdentifiers_1 = require("../../../container/ServiceIdentifiers");
const VMOpCode_1 = require("../../../enums/vm-transformers/VMOpCode");
const VMConstants_1 = require("../../VMConstants");
const NodeGuards_1 = require("../../../node/NodeGuards");
let VMExpressionBytecodeCompiler = class VMExpressionBytecodeCompiler {
    constructor(literalCompiler, operatorCompiler, assignmentCompiler, callCompiler, memberAccessCompiler, classCompiler, vmCompilerUtils) {
        this.literalCompiler = literalCompiler;
        this.operatorCompiler = operatorCompiler;
        this.assignmentCompiler = assignmentCompiler;
        this.callCompiler = callCompiler;
        this.memberAccessCompiler = memberAccessCompiler;
        this.classCompiler = classCompiler;
        this.vmCompilerUtils = vmCompilerUtils;
    }
    compileExpression(node, context) {
        if (this.compileLiteralExpression(node, context)) {
            return;
        }
        if (this.compileOperatorExpression(node, context)) {
            return;
        }
        if (this.compileSpecialExpression(node, context)) {
            return;
        }
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        builder.pushUndefined();
    }
    compileBinaryExpression(node, context) {
        this.operatorCompiler.compileBinaryExpression(node, context);
    }
    compileUnaryExpression(node, context) {
        this.operatorCompiler.compileUnaryExpression(node, context);
    }
    compileLogicalExpression(node, context) {
        this.operatorCompiler.compileLogicalExpression(node, context);
    }
    compileCallExpression(node, context) {
        var _a, _b;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        if (NodeGuards_1.NodeGuards.isIdentifierNode(node.callee) && node.callee.name === 'Symbol') {
            if (node.arguments.length === 0) {
                builder.createSymbol(null);
            }
            else {
                const descArg = node.arguments[0];
                if (NodeGuards_1.NodeGuards.isSpreadElementNode(descArg)) {
                    this.callCompiler.compileCallExpression(node, context);
                    return;
                }
                (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(descArg);
                builder.createSymbol(0);
            }
            return;
        }
        if (NodeGuards_1.NodeGuards.isMemberExpressionNode(node.callee) &&
            NodeGuards_1.NodeGuards.isIdentifierNode(node.callee.object) &&
            node.callee.object.name === 'Symbol' &&
            NodeGuards_1.NodeGuards.isIdentifierNode(node.callee.property) &&
            node.callee.property.name === 'for' &&
            !node.callee.computed) {
            if (node.arguments.length > 0) {
                const keyArg = node.arguments[0];
                if (NodeGuards_1.NodeGuards.isLiteralNode(keyArg) && typeof keyArg.value === 'string') {
                    const keyIndex = context.constantPool.add(keyArg.value);
                    builder.symbolFor(keyIndex);
                    return;
                }
            }
        }
        if (NodeGuards_1.NodeGuards.isMemberExpressionNode(node.callee) &&
            NodeGuards_1.NodeGuards.isIdentifierNode(node.callee.object) &&
            node.callee.object.name === 'Symbol' &&
            NodeGuards_1.NodeGuards.isIdentifierNode(node.callee.property) &&
            node.callee.property.name === 'keyFor' &&
            !node.callee.computed) {
            if (node.arguments.length > 0) {
                const symbolArg = node.arguments[0];
                (_b = context.dispatch) === null || _b === void 0 ? void 0 : _b.expression(symbolArg);
                builder.symbolKeyFor();
                return;
            }
        }
        this.callCompiler.compileCallExpression(node, context);
    }
    compileMemberExpression(node, context) {
        this.memberAccessCompiler.compileMemberExpression(node, context);
    }
    compileAssignmentExpression(node, context) {
        this.assignmentCompiler.compileAssignmentExpression(node, context);
    }
    compileConditionalExpression(node, context) {
        var _a, _b, _c;
        (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(node.test);
        const jumpToAlternateIndex = this.vmCompilerUtils.emitConditionalJump(VMOpCode_1.VMOpCode.JUMP_IF_FALSE, context);
        (_b = context.dispatch) === null || _b === void 0 ? void 0 : _b.expression(node.consequent);
        const jumpToEndIndex = this.vmCompilerUtils.emitConditionalJump(VMOpCode_1.VMOpCode.JUMP, context);
        this.vmCompilerUtils.patchJump(jumpToAlternateIndex, context);
        (_c = context.dispatch) === null || _c === void 0 ? void 0 : _c.expression(node.alternate);
        this.vmCompilerUtils.patchJump(jumpToEndIndex, context);
    }
    compileUpdateExpression(node, context) {
        this.operatorCompiler.compileUpdateExpression(node, context);
    }
    compileNewExpression(node, context) {
        this.callCompiler.compileNewExpression(node, context);
    }
    compileSequenceExpression(node, context) {
        var _a;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        for (let i = 0; i < node.expressions.length; i++) {
            (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(node.expressions[i]);
            if (i < node.expressions.length - 1) {
                builder.pop();
            }
        }
    }
    compileTaggedTemplateExpression(node, context) {
        this.literalCompiler.compileTaggedTemplateExpression(node, context);
    }
    compileAwaitExpression(node, context) {
        var _a;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(node.argument);
        builder.await();
    }
    compileYieldExpression(node, context) {
        var _a;
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        if (node.argument) {
            (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(node.argument);
        }
        else {
            builder.pushUndefined();
        }
        if (node.delegate) {
            builder.yieldStar();
        }
        else {
            builder.yield();
        }
    }
    compileChainExpression(node, context) {
        var _a;
        (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.expression(node.expression);
    }
    compileThisExpression(context) {
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        if (context.isArrowFunction) {
            context.capturedThis = true;
            context.capturedVars.add(VMConstants_1.VM_SPECIAL_VARS.capturedThis);
            builder.loadFromEnvByName(VMConstants_1.VM_SPECIAL_VARS.capturedThis);
        }
        else {
            builder.this();
        }
    }
    compileMetaProperty(node, context) {
        const builder = this.vmCompilerUtils.createInstructionBuilder(context);
        if (node.type !== 'MetaProperty') {
            builder.pushUndefined();
            return;
        }
        if (node.meta.name === 'new' && node.property.name === 'target') {
            builder.newTarget();
        }
        else {
            builder.pushUndefined();
        }
    }
    compileLiteralExpression(node, context) {
        switch (node.type) {
            case 'Literal':
                this.literalCompiler.compileLiteral(node, context);
                return true;
            case 'Identifier':
                this.literalCompiler.compileIdentifier(node, context);
                return true;
            case 'ArrayExpression':
                this.literalCompiler.compileArrayExpression(node, context);
                return true;
            case 'ObjectExpression':
                this.literalCompiler.compileObjectExpression(node, context);
                return true;
            case 'TemplateLiteral':
                this.literalCompiler.compileTemplateLiteral(node, context);
                return true;
            case 'ThisExpression':
                this.compileThisExpression(context);
                return true;
            case 'MetaProperty':
                this.compileMetaProperty(node, context);
                return true;
            default:
                return false;
        }
    }
    compileOperatorExpression(node, context) {
        switch (node.type) {
            case 'BinaryExpression':
                this.compileBinaryExpression(node, context);
                return true;
            case 'UnaryExpression':
                this.compileUnaryExpression(node, context);
                return true;
            case 'LogicalExpression':
                this.compileLogicalExpression(node, context);
                return true;
            case 'ConditionalExpression':
                this.compileConditionalExpression(node, context);
                return true;
            case 'AssignmentExpression':
                this.compileAssignmentExpression(node, context);
                return true;
            case 'UpdateExpression':
                this.compileUpdateExpression(node, context);
                return true;
            default:
                return false;
        }
    }
    compileSpecialExpression(node, context) {
        if (this.compileFunctionObjectExpression(node, context)) {
            return true;
        }
        return this.compileAsyncExpression(node, context);
    }
    compileFunctionObjectExpression(node, context) {
        var _a;
        switch (node.type) {
            case 'CallExpression':
                this.compileCallExpression(node, context);
                return true;
            case 'MemberExpression':
                this.compileMemberExpression(node, context);
                return true;
            case 'FunctionExpression':
            case 'ArrowFunctionExpression':
                (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.functionExpression(node);
                return true;
            case 'ClassExpression':
                this.classCompiler.compileClassExpression(node, context);
                return true;
            case 'NewExpression':
                this.compileNewExpression(node, context);
                return true;
            case 'SequenceExpression':
                this.compileSequenceExpression(node, context);
                return true;
            default:
                return false;
        }
    }
    compileAsyncExpression(node, context) {
        switch (node.type) {
            case 'TaggedTemplateExpression':
                this.compileTaggedTemplateExpression(node, context);
                return true;
            case 'AwaitExpression':
                this.compileAwaitExpression(node, context);
                return true;
            case 'YieldExpression':
                this.compileYieldExpression(node, context);
                return true;
            case 'ChainExpression':
                this.compileChainExpression(node, context);
                return true;
            default:
                return false;
        }
    }
};
exports.VMExpressionBytecodeCompiler = VMExpressionBytecodeCompiler;
exports.VMExpressionBytecodeCompiler = VMExpressionBytecodeCompiler = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMLiteralBytecodeCompiler)),
    __param(1, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMOperatorCompiler)),
    __param(2, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMAssignmentCompiler)),
    __param(3, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMCallCompiler)),
    __param(4, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMMemberAccessCompiler)),
    __param(5, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMClassBytecodeCompiler)),
    __param(6, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMCompilerUtils)),
    __metadata("design:paramtypes", [typeof (_a = typeof IVMLiteralBytecodeCompiler_1.IVMLiteralBytecodeCompiler !== "undefined" && IVMLiteralBytecodeCompiler_1.IVMLiteralBytecodeCompiler) === "function" ? _a : Object, typeof (_b = typeof IVMOperatorCompiler_1.IVMOperatorCompiler !== "undefined" && IVMOperatorCompiler_1.IVMOperatorCompiler) === "function" ? _b : Object, typeof (_c = typeof IVMAssignmentCompiler_1.IVMAssignmentCompiler !== "undefined" && IVMAssignmentCompiler_1.IVMAssignmentCompiler) === "function" ? _c : Object, typeof (_d = typeof IVMCallCompiler_1.IVMCallCompiler !== "undefined" && IVMCallCompiler_1.IVMCallCompiler) === "function" ? _d : Object, typeof (_e = typeof IVMMemberAccessCompiler_1.IVMMemberAccessCompiler !== "undefined" && IVMMemberAccessCompiler_1.IVMMemberAccessCompiler) === "function" ? _e : Object, typeof (_f = typeof IVMClassBytecodeCompiler_1.IVMClassBytecodeCompiler !== "undefined" && IVMClassBytecodeCompiler_1.IVMClassBytecodeCompiler) === "function" ? _f : Object, typeof (_g = typeof IVMCompilerUtils_1.IVMCompilerUtils !== "undefined" && IVMCompilerUtils_1.IVMCompilerUtils) === "function" ? _g : Object])
], VMExpressionBytecodeCompiler);
